import { React, useState, useContext } from 'react'

// Components
import Menu from 'components/layout/Menu/Menu'

// Logo Afopa
// import Logo from 'components/ui/Logo/Logo'

// Logo Codina Assessors
import Logo from 'components/ui/Logo/LogoCodina'

import Notifications from './Notifications/Notifications'

import { UserContext } from 'contexts/UserContext';

import UserIcon from 'assets/icons/user-alt-1-svgrepo-com.svg'
import EmailIcon from 'assets/icons/email-svgrepo-com.svg'
import RoleIcon from 'assets/icons/work-alt-svgrepo-com.svg'

// Icons
import CloseMenuIcon from 'components/icons/CloseMenuIcon'
import MobileMenuIcon from 'components/icons/MobileMenuIcon'
// import SearchIcon from 'components/icons/SearchIcon'

export default function Navbar() {
  const [mobileMenu, setMobileMenu] = useState(false)

  const handleMobileMenu = () => {
    setMobileMenu(!mobileMenu)
  }

   const {user} = useContext(UserContext);
    // console.log('User Context:', user);

return (
    <nav className="sticky top-0 z-50 py-2 bg-gray-100 border-b-8 border-indigo-900 print:hidden">
      <div className="w-full px-4 mx-auto sm:px-6 lg:px-2">
        <div className="flex items-center justify-between h-24">
          {/* Si logo = Logo */}
          <div className="flex items-center h-full">
            <div className="h-full mr-2">
              <Logo link="/" />
            </div>
            <div className="flex items-center h-full text-xl font-bold border-l border-indigo-900 border-dashed text">
              <span className="ml-8 text-2xl text-black">
                {window.location.href.includes('cadi')
                  ? 'Gestió Codina Assessors'
                  : 'Gestió Codina Assessors'}
              </span>
            </div>
          </div>
          {/* Nombre y email del usuario con íconos */}
          <div className="flex-col hidden text-right md:flex">
            <div className="flex items-center">
              <img src={UserIcon} alt="User Icon" className="w-5 h-5 mr-2" />
              <span className="text-sm font-medium text-gray-800">
                {user?.name || '-'}
              </span>
            </div>
            <div className="flex items-center">
              <img src={EmailIcon} alt="Email Icon" className="w-5 h-5 mr-2" />
              <span className="text-sm font-medium text-gray-800">
                {user?.email || '-'}
              </span>
            </div>
            {/* Rol */}
            <div className="flex items-center">
              <img src={RoleIcon} alt="Role Icon" className="w-5 h-5 mr-2" />
              <span className="text-sm font-medium text-gray-800">
                {user?.role_id === 2
                  ? 'Superadmin Codina'
                  : user?.role_id === 1
                  ? 'Administrador Centre'
                  : '-'}
              </span>
            </div>
          </div>
          <div className="flex -mr-2 md:hidden">
            {/* Mobile menu button */}
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 text-white rounded-md hover:text-white focus:outline-none"
              aria-controls="mobile-menu"
              aria-expanded="false"
              onClick={handleMobileMenu}
            >
              <span className="sr-only">Open main menu</span>
              {!mobileMenu ? (
                <MobileMenuIcon className="w-8 h-8" />
              ) : (
                <CloseMenuIcon className="w-8 h-8" />
              )}
            </button>
          </div>
        </div>
      </div>

      <div className={`md:hidden ${!mobileMenu && 'hidden'}`} id="mobile-menu">
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          <Menu device="mobile" handleMobileMenu={handleMobileMenu} />
        </div>
        <div className="pt-4 pb-3 border-t border-red-600">
          <div className="flex items-center px-5">
            <Notifications device="mobile" />
          </div>
        </div>
      </div>
    </nav>
  )
}

